module.exports = __webpack_public_path__ + "static/media/IconPlay.20483654.svg";